export class Arr {
  public static firstOrDefault<T>(array: T[]): T | null {
    return Array.isArray(array) && array.length > 0 ? array[0] : null
  }

  public static lastOrDefault<T>(array: T[]): T | null {
    return Array.isArray(array) && array.length > 0 ? array[array.length - 1] : null
  }

  public static isLongerThan(array: unknown[], length: number): boolean {
    return Array.isArray(array) && array.length > length
  }

  public static isLongerOrEqual(array: unknown[], length: number): boolean {
    return Array.isArray(array) && array.length >= length
  }

  public static isShorterThan(array: unknown[], length: number): boolean {
    return Array.isArray(array) && array.length < length
  }

  public static isShorterOrEqual(array: unknown[], length: number): boolean {
    return Array.isArray(array) && array.length <= length
  }

  public static isNullOrEmpty(array: unknown[]): boolean {
    return !array || (Array.isArray(array) && array.length === 0)
  }

  public static any(array: unknown[]): boolean {
    return Array.isArray(array) && array.length > 0
  }

  public static isEmpty(array: unknown[]): boolean {
    return Array.isArray(array) && array.length === 0
  }

  public static filterTrue<T>(array: (T | undefined)[]): T[] {
    return Array.isArray(array) ? (array.filter((e) => !!e) as T[]) : []
  }

  public static groupBy<T>(array: T[], groupBy: keyof T): { [key: string]: T[] } {
    const result: { [key: string]: T[] } = {}

    for (const item of array) {
      const val = item[groupBy] as string
      if (!result[val]) {
        result[val] = []
      }
      result[val].push(item)
    }

    return result
  }

  public static sortBy<T>(array: T[], sortBy: keyof T, ascending = true): T[] {
    const order = ascending ? 1 : -1
    return array.sort((a, b) => {
      if (a[sortBy] < b[sortBy]) {
        return -1 * order
      }
      if (a[sortBy] > b[sortBy]) {
        return 1 * order
      }
      return 0
    })
  }

  public static toObject<T, U>(items: T[], keySelector: (item: T, index: number) => string, valueSelector: (item: T, index: number) => U) {
    const result: Record<string, U | undefined> = {};
    for (let i = 0; i < items.length; i++) {
      const key = keySelector(items[i], i);
      result[key] = valueSelector(items[i], i);
    }
    return result;
  }
}
